import { c as _c } from "react/compiler-runtime";
import type { FreezeOnMessage } from '@module/types/centrifuge/public-message/freezeMessageTypes';
interface Props {
  item: FreezeOnMessage;
}
export default function FreezeOnChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.name}에 의해 채팅창이 ${message.messageType === "past" ? "\uC7A0\uACA8 \uC788\uC2B5\uB2C8\uB2E4." : "\uC7A0\uACBC\uC2B5\uB2C8\uB2E4."}`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_1"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}